import { createContext, useReducer } from "react";
import authState from "./State";
import authReducers from "./Reducers";

export const AuthContext = createContext(authState);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(authReducers, authState);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
